//=require main.js


!function ($, callback) {
    if (typeof $ === 'undefined') {
        $ = require('jquery');
    }

    callback($);
} (window.jQuery, function ($) {
    $(function () {
        const $progress = $('#progress');
        const $stepDescriptionBlock = $('.step-description-block-item');
        const $prev = $('#prev');
        const $next = $('#next');
        const $circles = $('.circle');
        const $start = $('.btn-step .btn-start');
        const len = $circles.length;
        const maxSize = 768;

        let curStep = 0;

        $next.click(function () {
            curStep = curStep + 1;
            if (curStep >= len) {
                curStep = len - 1;
            }

            update();
        });

        $circles.click(function () {
            const circleStep = Number($(this).find('span').text().slice(1, 2)) - 1;

            curStep = circleStep;
            if (curStep >= len) {
                curStep = len - 1;
            }

            update();
        });

        $prev.click(function () {
            curStep = curStep - 1;
            if (curStep <= 0) {
                curStep = 0;
            }
            update();
        });

        function updateStatus() {
            if (curStep === 0) {
                $prev.hide();
                $next.show();
                $start.addClass('d-none');
            } else if (curStep >= len - 1) {
                $prev.show();
                $next.hide();
                $start.removeClass('d-none');
            } else {
                $prev.show();
                $next.show();
                $start.addClass('d-none');
            }
        }

        function update() {

            $circles.removeClass('active');

            $circles.each(function(idx) {
                const $this = $(this);

                if (idx <= curStep) {
                    $this.addClass('active');
                }
            });

            $stepDescriptionBlock.addClass('d-none');
            $stepDescriptionBlock.eq(curStep).removeClass('d-none');

            const progressWidth = ((curStep / (len - 1)) * 100) + '%';

            const winWidth = $(window).width();

            $progress.css(winWidth >= maxSize ? 'width' : 'height', progressWidth);

            updateStatus();
        }

        update();

        let resizeTimeout;
        $(window).on('resize.step', function () {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(function () {
                $progress.removeAttr('style');
                update();
            }, 50);
        });
    });
});
